/**
 * Returns a prefix for Stripe keys based on the purchase attempt.
 * This is used to remount the Stripe element provider after failures.
 */
export const getStripeKeyPrefix = (purchaseAttempt: number) => {
  return `stripe-sdk-purchase-attempt-${purchaseAttempt}`;
};
